import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ToastService } from '../services/toast.service';

@Component({
	selector: 'app-auth-callback',
	template: `<p>Redirecting...</p>`,
})
export class AuthCallbackComponent implements OnInit {
	constructor(
		private authService: AuthenticationService,
		private route: ActivatedRoute,
		private router: Router,
		private toastService: ToastService,
	) {}

	ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			const token = params.token;

			if (token) {
				// Save the token in localStorage or a secure location
				this.authService.token = token;

				// Redirect to the dashboard
				this.router.navigate(['/app', 'dashboard']);
			} else {
				// Handle error (e.g., token missing)
				this.toastService.showToastOnError('Ein Fehler ist aufgetreten. Bitte versuche es später erneut.');
				this.router.navigate(['/login']);
			}
		});
	}
}
